import React from 'react';
import { Layout, Typography } from 'antd';
import { Helmet } from 'react-helmet-async';
import { Card, Row, Col } from 'antd';
import './PrivacyPage.css'; // Wiederverwenden des Privacy-Page-Styles für Konsistenz

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const ImpressumPage = () => {
    return (
        <div className="privacy-page"> {/* Wiederverwenden der Klasse für Styling */}
            <Helmet>
                <title>Impressum | Snus Verzeichnis Deutschland</title>
                <meta name="description" content="Impressum von Snus Verzeichnis Deutschland (Heinz Consulting). Rechtliche Hinweise und Kontaktinformationen." />
                <meta name="robots" content="noindex, follow" />
                <link rel="canonical" href="https://www.snus-finder.de/impressum" />
            </Helmet>

            <div className="privacy-header">
                <div className="container">
                    <Title level={1}>Impressum</Title>
                </div>
            </div>

            <div className="container">
                <Row justify="center">
                    <Col xs={24} md={20} lg={16}>
                        <Card style={{ marginBottom: '24px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
                            <Title level={2} style={{ marginBottom: '20px' }}>Angaben gemäß § 5 TMG</Title>
                            <Paragraph>
                                <Text strong>Heinz Consulting</Text><br />
                                Helmut Heinz<br />
                                Knollstraße 17<br />
                                72072 Tübingen<br />
                                Deutschland
                            </Paragraph>

                            <Title level={3} style={{ marginTop: '30px', marginBottom: '10px' }}>Kontakt</Title>
                            <Paragraph>
                                Telefon: 01733958762<br />
                                E-Mail: info.snusfinder@gmail.com
                            </Paragraph>

                            {/* Optional: Umsatzsteuer-ID (falls vorhanden) -> Auskommentiert lassen */}
                            {/*
                            <Title level={3} style={{ marginTop: '30px', marginBottom: '10px' }}>Umsatzsteuer-ID</Title>
                            <Paragraph>
                                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                                DE123456789
                            </Paragraph>
                            */}

                            <Title level={3} style={{ marginTop: '30px', marginBottom: '10px' }}>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</Title>
                            <Paragraph>
                                Helmut Heinz<br />
                                Knollstraße 17<br />
                                72072 Tübingen
                            </Paragraph>

                            <Title level={3} style={{ marginTop: '30px', marginBottom: '10px' }}>Haftungsausschluss (Disclaimer)</Title>
                            <Paragraph>
                                <Text strong>Haftung für Inhalte</Text><br />
                                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                            </Paragraph>
                            <Paragraph>
                                <Text strong>Haftung für Links</Text><br />
                                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                            </Paragraph>
                            <Paragraph>
                                <Text strong>Urheberrecht</Text><br />
                                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                            </Paragraph>
                            {/* Hinweis */}
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default ImpressumPage; 